import { useQuery } from "graphql-hooks";
import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { Row } from 'reactstrap';
import Helper from '../../utilities/helper';
import { PermissionsGate } from '../../utilities/PermissionsGate';
import { ACCESS_VALUES, PageNames } from '../../utilities/constValues';
import { PermissionsRequired } from '../Shared/PermissionsRequired';
import { ErrorPage } from '../Shared/ErrorPage';
import { Hero } from '../Shared/Hero';
import { Loading } from '../Shared/Loading';
import { MetaTags } from '../Shared/MetaTags';
import { CookieContainer } from './CookieContainer';
import { ContentBlock } from "../Shared/Content/ContentBlock";
import { ContentBody } from "../Shared/Content/ContentBody";
import { useAPIErrorContext } from '../../contexts/apiErrorContext';


const CMS_QUERY = `query datoQuery {
    pageData: pagePrivacy {
        fieldBodyContent1
        fieldBodyContent2
        fieldHeroTitle
        seo: _seoMetaTags {
            attributes
            content
            tag
        }
    }
}
`;

export const PrivacyStatement = () => {
    const { loading, error, data } = useQuery(CMS_QUERY);
    const { trackError } = useAPIErrorContext();

    const location = useLocation();
    React.useEffect(() => {
        Helper.setPagePath(location.pathname);
    }, [location]);

    const formatForTables = (content: string) => {
        let newContent = content.replace('<table>', '<div class="tableWrapper"><table>');
        newContent = newContent.replace('</table>', '</table></div>');
        return newContent;
    }

    if (!error && !loading) {
        return (
            <PermissionsGate requestedPermission={ACCESS_VALUES.Resources} renderError={<PermissionsRequired showParticipantMsg={true} />} pageName={PageNames.PrivacyStatement}>
            <div className="privacyStatement">
                <Hero pageTitle={data.pageData.fieldHeroTitle} />
                <ContentBlock className="privacyStatementContent">
                    <ContentBody>
                        <div dangerouslySetInnerHTML={{ __html: formatForTables(data.pageData.fieldBodyContent1) }} />
                        <CookieContainer />
                        <div dangerouslySetInnerHTML={{ __html: formatForTables(data.pageData.fieldBodyContent2) }} />
                    </ContentBody>
                </ContentBlock>
                <MetaTags seoData={data.pageData.seo} />
            </div>
            </PermissionsGate>
        );
    }
    else if (!error) {
        return (<Loading showContent={true} includeHero={true} />);
    }
    else {
        trackError("Dato error", JSON.stringify(error));
        return (<ErrorPage showContactForm={true} includeHero={true} />);
    }
};
